import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    badge: {
      '&& .MuiBadge-dot': {
        outline: 'solid 2px white',
      },
    },
  }),
);
